// Lightweight GA4 helpers + global click-to-call tracking.
// Fires `click_to_call` events for any anchor with an href starting `tel:`.

type GtagFn = (...args: unknown[]) => void;

export const gaEvent = (name: string, params: Record<string, unknown> = {}) => {
  if (typeof window === "undefined") return;
  const gtag = (window as unknown as { gtag?: GtagFn }).gtag;
  if (typeof gtag !== "function") return;
  gtag("event", name, { debug_mode: true, ...params });
};

let installed = false;

export const installClickToCallTracking = () => {
  if (installed || typeof document === "undefined") return;
  installed = true;

  document.addEventListener(
    "click",
    (e) => {
      const target = e.target as HTMLElement | null;
      const anchor = target?.closest?.('a[href^="tel:"]') as HTMLAnchorElement | null;
      if (!anchor) return;
      const phone = anchor.getAttribute("href")?.replace(/^tel:/, "") ?? "";
      gaEvent("click_to_call", {
        phone_number: phone,
        link_text: (anchor.textContent || "").trim().slice(0, 100),
        page_location: window.location.pathname,
      });
    },
    { capture: true }
  );
};
